const ArrowDownSmallIcon = () => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.41707 0.999923L6.0029 4.58574L9.5887 0.999923C9.9792 0.609403 10.6123 0.609403 11.0029 0.999923C11.0517 1.04874 11.0944 1.10134 11.131 1.15684C11.3873 1.54494 11.3446 2.07244 11.0029 2.41414L6.71 6.70704C6.5224 6.89454 6.2681 6.99994 6.0029 6.99994C5.7376 6.99994 5.4833 6.89454 5.2958 6.70704L1.00285 2.41414C0.612331 2.02364 0.612331 1.39044 1.00285 0.999923C1.05167 0.951113 1.10428 0.908394 1.15973 0.871784C1.54788 0.615504 2.07536 0.658213 2.41707 0.999923Z"
        fill="white"
      />
    </svg>
  );
};

const EditPencilIcon = () => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4727 8.64423L14.3544 9.52589L5.67187 18.2084H4.7902V17.3267L13.4727 8.64423ZM16.9227 2.87506C16.6831 2.87506 16.434 2.97089 16.2519 3.15298L14.4981 4.90673L18.0919 8.50048L19.8456 6.74673C20.2194 6.37298 20.2194 5.76923 19.8456 5.39548L17.6031 3.15298C17.4115 2.96131 17.1719 2.87506 16.9227 2.87506ZM13.4727 5.93214L2.87354 16.5313V20.1251H6.46729L17.0665 9.52589L13.4727 5.93214Z"
        fill="#143784"
      />
    </svg>
  );
};

export { ArrowDownSmallIcon, EditPencilIcon };
